import { render, staticRenderFns } from "./r-guard-dialog.vue?vue&type=template&id=8421c1a0&scoped=true"
import script from "./r-guard-dialog.vue?vue&type=script&lang=js"
export * from "./r-guard-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-guard-dialog.vue?vue&type=style&index=0&id=8421c1a0&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8421c1a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8421c1a0')) {
      api.createRecord('8421c1a0', component.options)
    } else {
      api.reload('8421c1a0', component.options)
    }
    module.hot.accept("./r-guard-dialog.vue?vue&type=template&id=8421c1a0&scoped=true", function () {
      api.rerender('8421c1a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/guard/r-guard-dialog.vue"
export default component.exports